var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "drawer-page" },
        [
          _c("div", { staticClass: "drawer-page-title" }, [
            _vm._v(_vm._s(_vm.$t("language.addCloud.connectDesc")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "drawer-page-body" }, [
            _c(
              "div",
              { staticClass: "drawer-page-personal" },
              [
                _c("div", { staticClass: "add-txt" }, [
                  _vm._v(_vm._s(_vm.$t("language.addCloud.peCloud")))
                ]),
                _vm._v(" "),
                _c(
                  "el-scrollbar",
                  { ref: "pageScrollbar", staticStyle: { height: "100%" } },
                  [
                    _c(
                      "div",
                      { staticClass: "drawer-page-add-body" },
                      _vm._l(_vm.addCloudLineUp, function(item, index) {
                        return item.appName.indexOf("_v2") == -1 &&
                          item.appName != "oneDrive" &&
                          item.appName != "googlePhotos"
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticClass: "drive-add-cloud",
                                on: {
                                  click: function($event) {
                                    return _vm.addCloudDialog(item)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "add-cloud-item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "add-cloud-center" },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "cloud cloud-size cloudPosition",
                                        class: item.appName
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "add-cloud-item-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.addCloud." +
                                                  item.appName
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "drawer-page-business" },
              [
                _c("div", { staticClass: "add-txt" }, [
                  _vm._v(_vm._s(_vm.$t("language.addCloud.buCloud")))
                ]),
                _vm._v(" "),
                _c(
                  "el-scrollbar",
                  { ref: "pageScrollbar", staticStyle: { height: "100%" } },
                  [
                    _c(
                      "div",
                      { staticClass: "drawer-page-add-body" },
                      _vm._l(_vm.addCloudLineDown, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "drive-add-cloud",
                            on: {
                              click: function($event) {
                                return _vm.addCloudDialog(item)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "add-cloud-item" }, [
                              _c("div", { staticClass: "add-cloud-center" }, [
                                _c("div", {
                                  staticClass: "cloud cloud-size cloudPosition",
                                  class: item.appName
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "add-cloud-item-name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.addCloud." + item.appName
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("addCloudDialog", { ref: "addCloudDialog" }),
          _vm._v(" "),
          _c("addFtpDialog", { ref: "addFtpDialog" }),
          _vm._v(" "),
          _c("addNasDialog", { ref: "addNasDialog" }),
          _vm._v(" "),
          _c("addSpecialDialog", { ref: "addSpecialDialog" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34da6015", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34da6015","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/drawer/page/add_cloud.vue
// module id = null
// module chunks = 